import { getCognitoToken } from '.';

interface GetTokenCallbackInput {
    clientId: string;
    userPoolId: string;
}

/**
 * Returns a GetToken callback that can be used in code that sits above the ModalProvider in the
 * component tree. If the calling code is within the ModalProvider, it should use the getToken
 * function returned by useTokenModal instead.
 * @param input - see {@link GetTokenCallbackInput}
 * @returns a GetToken callback
 */
export const getTokenCallback = ({
    clientId,
    userPoolId,
}: GetTokenCallbackInput): GetToken => {
    const getToken = (
        handleToken: TokenCallback,
        handleTokenMissing?: () => void,
    ): void => {
        const doGetCognitoToken = async (): Promise<boolean> => {
            const { token } = await getCognitoToken({
                clientId,
                userPoolId,
            });

            if (token !== null) {
                handleToken(token);
            } else if (handleTokenMissing) {
                handleTokenMissing();
            }

            // This value isn't used anywhere; we just return a consistent type for linting and
            // typechecking purposes.
            return true;
        };

        doGetCognitoToken();
    };

    return getToken;
};
